import { url, tokenRef } from "api";

// ==================== HELPERS ====================
const getHeaders = () => {
  const headers = {
    "Content-Type": "application/json",
  };

  const userToken = localStorage.getItem(tokenRef);
  if (userToken) {
    headers["Authorization"] = `Bearer ${userToken}`;
  }

  return headers;
};

const handleResponse = async (response) => {
  const data = await response.json();
  if (!response.ok) {
    const error = new Error(data.err || "Request failed");
    error.status = response.status;
    error.data = data;
    throw error;
  }
  return data;
};

// ==================== NOTIFICATIONS ====================

/**
 * List notifications, newest first.
 * Rows: {_id,type,title,body,link,readAt,createdAt,issueId,projectId}
 * options: {unread?:boolean, limit?:number}
 */
export const getNotifications = async ({ unread, limit } = {}) => {
  const qs = new URLSearchParams();
  if (unread) qs.append("unread", "1");
  if (limit) qs.append("limit", limit);
  const query = qs.toString();
  const response = await fetch(`${url}/notifications${query ? `?${query}` : ""}`, {
    method: "GET",
    headers: getHeaders(),
  });
  return handleResponse(response);
};

/**
 * Unread badge count → {count}
 */
export const getUnreadCount = async () => {
  const response = await fetch(`${url}/notifications/unread-count`, {
    method: "GET",
    headers: getHeaders(),
  });
  return handleResponse(response);
};

/**
 * Mark one notification read
 */
export const markRead = async (id) => {
  const response = await fetch(`${url}/notifications/${id}/read`, {
    method: "PUT",
    headers: getHeaders(),
  });
  return handleResponse(response);
};

/**
 * Mark every unread notification read
 */
export const markAllRead = async () => {
  const response = await fetch(`${url}/notifications/read-all`, {
    method: "PUT",
    headers: getHeaders(),
  });
  return handleResponse(response);
};
